import React from 'react';
import CasoCard from './CasoCard';
import { accionDe } from './metricas';
import MiAnalisis from './MiAnalisis';
import ResultadoResumen from './ResultadoResumen';
import type { Accion, Caso, LecturaIACaso, Referencia, RunDetalle } from './tipos';
import { CHIP } from './ui';

/**
 * Un caso × N corridas: tarjeta compacta del caso, una celda por corrida (resultado +
 * "= tu acción / ≠ tu acción" + lo que la IA vio que omitió o inventó) y el panel
 * "Mi análisis".
 */
const FilaCasoComparar: React.FC<{
  caso: Caso;
  corridas: RunDetalle[];
  referencia: Referencia | undefined;
  lecturas: Map<string, LecturaIACaso> | undefined;
  fidelidadMax: number;
  onGuardarReferencia: (accion: Accion | null, texto: string) => Promise<void>;
}> = ({ caso, corridas, referencia, lecturas, fidelidadMax, onGuardarReferencia }) => (
  <CasoCard caso={caso} compacto>
    <div className="mt-1 space-y-2 border-t border-gray-100 pt-2">
      {/* Una columna por corrida: con 2 ocupan todo el ancho, con 8 se reparten en filas. Inline
          porque `grid-cols-[...]` arbitrario de Tailwind no compila en este repo. */}
      <div className="grid gap-2" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
        {corridas.map((d, i) => {
          const r = d.resultados.find((x) => x.imagen_id === caso.imagen_id);
          const accion = r ? accionDe(r) : null;
          const coincide = referencia && r && !r.error_analisis ? accion === referencia.accion : null;
          const ia = lecturas?.get(d.run.run_id);
          return (
            <div key={d.run.run_id} className="rounded-lg bg-gray-50 p-2">
              <div className="mb-1 flex flex-wrap items-center gap-1 text-[11px] text-gray-500">
                <b className="text-brand-black">#{i + 1}</b> {d.run.etiqueta} · {d.run.modelo}
                {coincide !== null && (
                  <span className={`${CHIP} ml-auto ${coincide ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    {coincide ? '= tu acción' : '≠ tu acción'}
                  </span>
                )}
              </div>
              <ResultadoResumen resultado={r} fidelidadMax={fidelidadMax} compacto />
              {ia && (
                <div className="mt-1 space-y-0.5 border-t border-gray-200 pt-1 text-[11px] leading-4">
                  {ia.omitidos.length > 0 && (
                    <p className="text-amber-700">
                      <b>Omitió:</b> {ia.omitidos.join(', ')}
                    </p>
                  )}
                  {ia.de_mas.length > 0 && (
                    <p className="text-red-700">
                      <b>De más:</b> {ia.de_mas.join(', ')}
                    </p>
                  )}
                  {ia.comentario && <p className="text-gray-600">{ia.comentario}</p>}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <MiAnalisis referencia={referencia} onGuardar={onGuardarReferencia} />
    </div>
  </CasoCard>
);

export default FilaCasoComparar;
